import { KeyboardEvent } from 'react';

import { InputBaseComponentProps, OutlinedInputProps, Typography } from '@mui/material';
import { TextFieldProps } from '@mui/material/TextField';

import { TextInputBox } from './style';

type BaseTextFieldProps = TextFieldProps & {
  onEnter?: Function;
  inputProps?: Partial<OutlinedInputProps>;
  inputPropsStyle?: InputBaseComponentProps;
};
export const TextArea = (props: BaseTextFieldProps) => {
  const { onEnter, inputProps, inputPropsStyle, ...filteredProps } = props;
  const onKeyDown = (event: KeyboardEvent<HTMLImageElement>) => {
    if (event.key === 'Enter') {
      if (onEnter) onEnter(event);
    }
  };

  return (
    <TextInputBox
      multiline
      fullWidth
      variant="outlined"
      sx={{
        '& .MuiOutlinedInput-root': {
          '&:hover fieldset': {
            borderColor: (theme) => theme.palette.primaryV2.main,
          },
        },
      }}
      {...filteredProps}
      onKeyDown={onKeyDown}
      InputProps={{ ...inputProps }}
      inputProps={{
        ...inputPropsStyle,
        style: {
          backgroundColor: 'white',
          padding: '0px 5px',
          overflow: 'auto',
          fontFamily: 'Heavent',
          fontSize: '20px',
          fontWeight: 400,
          lineHeight: '1.25',
          letterSpacing: '0em',
          textAlign: 'left',
          ...inputPropsStyle?.style,
        },
      }}
    />
  );
};
